<template>
  <div>
    <el-form ref="form" :model="form" :rules="rules" label-width="120px" size="mini" label-position="top">
      <el-card shadow="never">
        <el-form-item label="网站LOGO" required prop="logoList">
          <el-upload action="" :http-request="uploadFile" :on-remove="handleRemove" :on-change="handleChangeFile" :auto-upload="false" :limit="1" :on-exceed="handleExceed" :file-list="form.logoList" list-type="picture" style="width: 400px">
            <el-button size="mini" type="primary" plain>点击上传<i class="el-icon-upload el-icon--right"></i></el-button>
            <div slot="tip" class="el-upload__tip" style="width:600px;">
              <span>推荐尺寸: 300px *
                100px,或者宽高比为3:1,这样的展示效果最好！</span>
              <span style="margin-left: 10px">
                只能上传jpg/png文件，且不超过500kb</span>
            </div>
          </el-upload>
        </el-form-item>
      </el-card>

      <!-- <el-card style="margin-top: 20px" shadow="never">
        <el-button type="primary" @click="addLinks" size="mini" :disabled="tableData.length == 2">添加链接</el-button>
        <div class="classTable1">
          <el-table :row-key="index" style="margin-top: 20px;" :data="tableData"
            :header-cell-style="{ background: '#f5f7fa' }">
            <el-table-column prop="name" label="名称"></el-table-column>
            <el-table-column prop="link" label="链接"></el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button size="small" type="text" @click="updateLinks(scope.row, scope.$index)">修改</el-button>
                <el-button size="small" type="text" @click="deleteLinks(scope.row)">删除</el-button>
                <el-button size="small" type="text">
                  <i class="el-icon-rank"></i>
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-card> -->

      <el-card style="margin-top: 20px" shadow="never">
        <el-form-item label="联系人二维码" required prop="contantList">
          <el-upload action="" :http-request="uploadFile" :on-remove="handleRemove1" :on-change="handleChangeFile1" :auto-upload="false" :limit="1" :on-exceed="handleExceed1" :file-list="form.contantList" list-type="picture" style="width: 400px">
            <el-button size="mini" type="primary" plain>点击上传<i class="el-icon-upload el-icon--right"></i></el-button>
            <div slot="tip" class="el-upload__tip">
              只能上传jpg/png文件，且不超过500kb
            </div>
          </el-upload>
        </el-form-item>
      </el-card>

      <el-card style="margin-top: 20px" shadow="never">
        <el-form-item label="备案信息设置" required>
          <el-switch v-model="form.is_show_copy_right" active-text="开启" inactive-text="关闭" @change="updateCopyRight">
          </el-switch>
        </el-form-item>
      </el-card>
      <el-card style="margin-top: 20px" shadow="never">
        <el-form-item label="导航栏颜色设置">
          <el-color-picker v-model="theme" class="theme-picker" popper-class="theme-picker-dropdown" @change="changeColor">
          </el-color-picker>
        </el-form-item>
      </el-card>

      <el-form-item style="margin-top: 20px">
        <el-button type="primary" @click="submit('form')" size="small">保存</el-button>
        <el-button @click="resetHomepage('1')" size="small">重置</el-button>
      </el-form-item>
    </el-form>
    <!-- <el-dialog title="链接" :visible.sync="dialogVisible" width="800px">
      <el-form class="form-style" ref="form1" :model="form1" :rules="rules" label-width="200px" label-position="right">
        <el-form-item label="标题" required>
          <el-input placeholder="请输入标题" v-model="form1.name" style="width: 400px" maxlength="4" show-word-limit>
          </el-input>
        </el-form-item>

        <el-form-item label="链接" required>
          <el-input placeholder="请输入跳转链接" v-model="form1.link" style="width: 400px" maxlength="500" show-word-limit>
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" type="primary" @click="submit1('form1')">保存</el-button>
        <el-button size="small" @click="dialogVisible = false">关 闭</el-button>
      </span>
    </el-dialog> -->
  </div>
</template>
<script>
import {
  updateHomepage,
  resetHomepage,
  updateSchoolThemeColor,
} from '@/api/homeset'
import uploadFile from '@/config/uploadFile'
import { getHomepage } from "@/api/homeset";
// import Sortable from "sortablejs";

export default {
  name: 'homeset-logoset',
  props: {
    logo_img: String,
    contant_img: String,
    homepage_id: Number,
    is_show_copy_right: Boolean,
    self_header_button: Array,
  },
  data() {
    var validatePass = (rule, value, callback) => {
      if (!value.length) {
        callback(new Error('请上传图片'))
      } else {
        callback()
      }
    }

    return {
      tableIndex: 0,
      editIs: true,
      form1: {
        name: '',
        link: '',
      },
      dialogVisible: false,
      tableData: [],
      theme: '',

      islogo: false,
      form: {
        logoList: [],
        contantList: [],
        is_show_copy_right: null,
      },

      rules: {
        logoList: [{ validator: validatePass, trigger: 'change' }],
        contantList: [{ validator: validatePass, trigger: 'change' }],
        name: [{ required: true, message: '请输入标题', trigger: 'blur' }],
        link: [{ required: true, message: '请输入链接', trigger: 'blur' }],
      },
    }
  },
  watch: {
    self_header_button(val) {
      console.log(val, 789465456)
      this.tableData = val
    },
    theme(val) {
      console.log(val, 4444)
      this.theme = val
      console.log(this.theme, 5555)

      this.$store.commit('themeName', this.theme)
    },

    logo_img() {
      this.form.logoList = [
        {
          url: this.logo_img,
          name: this.logo_img.split('/')[this.logo_img.split('/').length - 1],
        },
      ]
    },
    contant_img() {
      this.form.contantList = [
        {
          url: this.contant_img,
          name: this.contant_img.split('/')[
            this.logo_img.split('/').length - 1
          ],
        },
      ]
    },

    is_show_copy_right() {
      console.log('备案信息状态')
      console.log(this.is_show_copy_right)
      this.form.is_show_copy_right = this.is_show_copy_right
    },
  },
  created() { },
  mounted() {
    // this.rowDrop1()
    // getHomepage().then((res) => {
    //   console.log(res)
    //   this.theme = res.schoolInfo.theme_color
    //   console.log(this.theme, 5555)
    //   this.$store.commit('themeName', this.theme)
    //   console.log(typeof this.theme, 5555)
    // })
  },
  methods: {
    // rowDrop1() {
    //   // 要侦听拖拽响应的DOM对象
    //   const tbody = document.querySelector(".classTable1 .el-table__body-wrapper tbody");
    //   const that = this;
    //   console.log(that.tableData, 4547878);
    //   Sortable.create(tbody, {
    //     animation: 1000,
    //     ghostClass: "ghostClass", //设置拖拽停靠样式类名
    //     chosenClass: "chosenClass", //设置选中样式类名
    //     handle: ".el-icon-rank",
    //     // 结束拖拽后的回调函数
    //     onEnd({ newIndex, oldIndex }) {
    //       console.log("拖动了行，当前序号：" + newIndex);
    //       const currentRow = that.tableData.splice(oldIndex, 1)[0];
    //       that.tableData.splice(newIndex, 0, currentRow);
    //       console.log(that.tableData, 123456);
    //       updateHomepage({
    //         id: that.homepage_id,
    //         self_header_button: JSON.stringify(that.tableData),
    //       }).then((res) => {
    //         if (res.is_update) {
    //           // that.dialogVisible = false
    //           console.log(res.result.self_header_button, 123456)
    //           that.tableData = []
    //           that.$nextTick(() => {
    //             that.tableData.push(...res.result.self_header_button)
    //             console.log(that.tableData, 123456)

    //           })

    //           that.$message.success("保存成功！");

    //         }
    //       });

    //     },
    //   });
    // },
    // deleteLinks(row) {
    //   this.tableData.splice(this.tableData.indexOf(row), 1);
    //   console.log(this.tableData, 21235)
    //   updateHomepage({
    //     id: this.homepage_id,
    //     self_header_button: JSON.stringify(this.tableData),
    //   }).then((res) => {
    //     if (res.is_update) {
    //       this.$message.success("保存成功！");
    //     }
    //   });
    // },
    // updateLinks(row, index) {
    //   this.editIs = false
    //   console.log(index, 123456)
    //   this.form1.name = row.name;
    //   this.form1.link = row.link;
    //   this.tableIndex = index
    //   this.dialogVisible = true;

    // },
    // addLinks() {
    //   this.editIs = true
    //   this.form1.name = "";
    //   this.form1.link = "";
    //   // this.form1.imageId = "";
    //   this.dialogVisible = true;
    // },
    // submit1(formName) {
    //   this.$refs[formName].validate((valid) => {
    //     if (valid) {
    //       if (this.editIs == true) {
    //         this.tableData.push(this.form1)
    //         console.log(this.tableData, 125458)
    //         updateHomepage({
    //           id: this.homepage_id,
    //           self_header_button: JSON.stringify(this.tableData),
    //         }).then((res) => {
    //           if (res.is_update) {
    //             this.$message.success("保存成功！");
    //             this.dialogVisible = false
    //             console.log(res.result.self_header_button, 1245645)
    //             this.tableData = res.result.self_header_button

    //           }
    //         });
    //       } else {
    //         this.tableData[this.tableIndex].name = this.form1.name
    //         this.tableData[this.tableIndex].link = this.form1.link
    //         console.log(this.tableData, 123456)
    //         updateHomepage({
    //           id: this.homepage_id,
    //           self_header_button: JSON.stringify(this.tableData),
    //         }).then((res) => {
    //           if (res.is_update) {
    //             this.$message.success("保存成功！");
    //             this.dialogVisible = false

    //           }
    //         });
    //       }

    //     }
    //   });
    // },
    changeColor(val) {
      console.log(val, 565656)
      updateSchoolThemeColor({
        theme_color: this.theme,
      }).then((res) => {
        console.log(res)
        this.$store.commit('themeName', this.theme)
        this.$message.success('换肤成功！')

        var navbar = document.querySelector('.header')
        navbar.style.backgroundColor = this.$store.state.theme.theme
      })
    },

    uploadFile() { },

    handleExceed() {
      this.$message.warning('请删除原有文件,再重新上传')
    },

    handleExceed1() {
      this.$message.warning('请删除原有文件,再重新上传')
    },

    handleRemove(file, fileList) {
      this.form.logoList = fileList
    },

    handleRemove1(file, fileList) {
      this.form.contantList = fileList
    },

    async handleChangeFile(file, fileList) {
      const beforeUploadImg = await this.beforeAvatarUpload(file)
      if (beforeUploadImg) {
        this.islogo = true
        if (!this.uploadFileTime) {
          await this.uploadFileOss(fileList)
        }
      } else {
        this.$message({
          message: `上传图片尺寸宽度必须小于900px!请重新选择!`,
          type: 'warning',
        })
        this.form.logoList.pop()
      }
    },
    beforeAvatarUpload(fileUrl) {
      let width = 900 // 最大尺寸900;
      return new Promise((resolve) => {
        let _URL = window.URL || window.webkitURL
        let img = new Image()
        img.onload = function () {
          let valid = img.width <= width
          resolve(valid)
        }
        img.src = _URL.createObjectURL(fileUrl.raw)
      })
    },
    async handleChangeFile1(file, fileList) {
      this.islogo = false
      if (!this.uploadFileTime) {
        await this.uploadFileOss(fileList)
      }
    },

    submit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          updateHomepage({
            id: this.homepage_id,
            logo_img_url: this.form.logoList[0].url,
            modal_img_url: this.form.contantList[0].url,
          }).then((res) => {
            if (res.is_update) {
              this.$message.success('保存成功！')
              // this.$store.dispatch('freshUserData')
              getHomepage().then((res) => {
                sessionStorage.setItem('schoolInfo', JSON.stringify(res))
              })
            }
          })
        }
      })
    },

    updateCopyRight() {
      updateHomepage({
        id: this.homepage_id,
        is_show_copy_right: this.form.is_show_copy_right ? '1' : '0',
      }).then((res) => {
        if (res.is_update) {
          this.$message.success('修改成功')
        }
      })
    },

    async uploadFileOss(list) {
      this.uploadFileTime = true
      await uploadFile(list, this.$store.state.user.userInfo.code).then(
        (res) => {
          if (this.islogo) {
            this.form.logoList = res
          } else {
            this.form.contantList = res
          }
          this.uploadFileTime = false
        }
      )
    },

    updateSchoolThemeColor() {
      updateSchoolThemeColor({
        theme_color: '#1778FF',
      }).then((res) => {
        console.log(res)
        this.$store.commit('themeName', this.theme)
      })
    },

    //重置校区信息
    resetHomepage(type) {
      this.$confirm('确定重置基础设置吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        resetHomepage({
          reset_type: type,
        }).then((res) => {
          console.log('重置信息')
          console.log(res)
          if (res.is_update) {
            this.$message.success('重置成功,请刷新本页面')
            this.updateSchoolThemeColor()
          }
        })
      })
    },
  },
}
</script>

<style scoped lang="scss">
.table-style {
  margin-top: 20px;
}
</style>
